import { config } from "../../Config";

const GetUserRole = async (userId) => {
  if (!userId) return { success: false, error: "Missing userId", role: "user" };
  const baseUrl = config.getUserRole;
  if (!baseUrl) return { success: false, error: "endpoint not configured", role: "user" };
  const url = new URL(baseUrl);
  url.searchParams.set("userId", userId);
  try {
    const res = await fetch(url.toString(), { method: "GET" });
    if (!res.ok) return { success: false, error: `HTTP ${res.status}`, role: "user" };
    const data = await res.json();
    return { success: true, role: data.role || "user" };
  } catch (e) {
    return { success: false, error: e.message, role: "user" };
  }
};

export default GetUserRole;
